/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DeleteResponse } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { WriteOffReasonPost } from '../models';
// @ts-ignore
import type { WriteOffReasonReorder } from '../models';
// @ts-ignore
import type { WriteOffReasonResponse } from '../models';
/**
 * WriteOffReasonApi - axios parameter creator
 * @export
 */
export const WriteOffReasonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a writeoff reason
         * @summary Delete a writeoff reason
         * @param {string} writeOffReasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWriteOffReason: async (writeOffReasonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'writeOffReasonId' is not null or undefined
            assertParamExists('deleteWriteOffReason', 'writeOffReasonId', writeOffReasonId)
            const localVarPath = `/api/v1/fhir/writeOffReason/{writeOffReasonId}`
                .replace(`{${"writeOffReasonId"}}`, encodeURIComponent(String(writeOffReasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all write off reasons
         * @summary Get all write off reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWriteOffReasons: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/fhir/writeOffReason`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch a write off reason
         * @summary Patch a write off reason
         * @param {WriteOffReasonPost} writeOffReasonPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWriteOffReason: async (writeOffReasonPost: WriteOffReasonPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'writeOffReasonPost' is not null or undefined
            assertParamExists('patchWriteOffReason', 'writeOffReasonPost', writeOffReasonPost)
            const localVarPath = `/api/v1/fhir/writeOffReason`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeOffReasonPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reorder writeOff reasons
         * @summary Reorder writeOff reasons
         * @param {Array<WriteOffReasonReorder>} writeOffReasonReorder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderWriteOffReasons: async (writeOffReasonReorder: Array<WriteOffReasonReorder>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'writeOffReasonReorder' is not null or undefined
            assertParamExists('reorderWriteOffReasons', 'writeOffReasonReorder', writeOffReasonReorder)
            const localVarPath = `/api/v1/fhir/writeOffReason/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeOffReasonReorder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WriteOffReasonApi - functional programming interface
 * @export
 */
export const WriteOffReasonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WriteOffReasonApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a writeoff reason
         * @summary Delete a writeoff reason
         * @param {string} writeOffReasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWriteOffReason(writeOffReasonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWriteOffReason(writeOffReasonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WriteOffReasonApi.deleteWriteOffReason']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all write off reasons
         * @summary Get all write off reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWriteOffReasons(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WriteOffReasonResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWriteOffReasons(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WriteOffReasonApi.getWriteOffReasons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch a write off reason
         * @summary Patch a write off reason
         * @param {WriteOffReasonPost} writeOffReasonPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchWriteOffReason(writeOffReasonPost: WriteOffReasonPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchWriteOffReason(writeOffReasonPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WriteOffReasonApi.patchWriteOffReason']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reorder writeOff reasons
         * @summary Reorder writeOff reasons
         * @param {Array<WriteOffReasonReorder>} writeOffReasonReorder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderWriteOffReasons(writeOffReasonReorder: Array<WriteOffReasonReorder>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderWriteOffReasons(writeOffReasonReorder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WriteOffReasonApi.reorderWriteOffReasons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WriteOffReasonApi - factory interface
 * @export
 */
export const WriteOffReasonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WriteOffReasonApiFp(configuration)
    return {
        /**
         * Delete a writeoff reason
         * @summary Delete a writeoff reason
         * @param {WriteOffReasonApiDeleteWriteOffReasonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWriteOffReason(requestParameters: WriteOffReasonApiDeleteWriteOffReasonRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponse> {
            return localVarFp.deleteWriteOffReason(requestParameters.writeOffReasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all write off reasons
         * @summary Get all write off reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWriteOffReasons(options?: RawAxiosRequestConfig): AxiosPromise<Array<WriteOffReasonResponse>> {
            return localVarFp.getWriteOffReasons(options).then((request) => request(axios, basePath));
        },
        /**
         * Patch a write off reason
         * @summary Patch a write off reason
         * @param {WriteOffReasonApiPatchWriteOffReasonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWriteOffReason(requestParameters: WriteOffReasonApiPatchWriteOffReasonRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchWriteOffReason(requestParameters.writeOffReasonPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Reorder writeOff reasons
         * @summary Reorder writeOff reasons
         * @param {WriteOffReasonApiReorderWriteOffReasonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderWriteOffReasons(requestParameters: WriteOffReasonApiReorderWriteOffReasonsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reorderWriteOffReasons(requestParameters.writeOffReasonReorder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WriteOffReasonApi - interface
 * @export
 * @interface WriteOffReasonApi
 */
export interface WriteOffReasonApiInterface {
    /**
     * Delete a writeoff reason
     * @summary Delete a writeoff reason
     * @param {WriteOffReasonApiDeleteWriteOffReasonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteOffReasonApiInterface
     */
    deleteWriteOffReason(requestParameters: WriteOffReasonApiDeleteWriteOffReasonRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponse>;

    /**
     * Get all write off reasons
     * @summary Get all write off reasons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteOffReasonApiInterface
     */
    getWriteOffReasons(options?: RawAxiosRequestConfig): AxiosPromise<Array<WriteOffReasonResponse>>;

    /**
     * Patch a write off reason
     * @summary Patch a write off reason
     * @param {WriteOffReasonApiPatchWriteOffReasonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteOffReasonApiInterface
     */
    patchWriteOffReason(requestParameters: WriteOffReasonApiPatchWriteOffReasonRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Reorder writeOff reasons
     * @summary Reorder writeOff reasons
     * @param {WriteOffReasonApiReorderWriteOffReasonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteOffReasonApiInterface
     */
    reorderWriteOffReasons(requestParameters: WriteOffReasonApiReorderWriteOffReasonsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for deleteWriteOffReason operation in WriteOffReasonApi.
 * @export
 * @interface WriteOffReasonApiDeleteWriteOffReasonRequest
 */
export interface WriteOffReasonApiDeleteWriteOffReasonRequest {
    /**
     * 
     * @type {string}
     * @memberof WriteOffReasonApiDeleteWriteOffReason
     */
    readonly writeOffReasonId: string
}

/**
 * Request parameters for patchWriteOffReason operation in WriteOffReasonApi.
 * @export
 * @interface WriteOffReasonApiPatchWriteOffReasonRequest
 */
export interface WriteOffReasonApiPatchWriteOffReasonRequest {
    /**
     * 
     * @type {WriteOffReasonPost}
     * @memberof WriteOffReasonApiPatchWriteOffReason
     */
    readonly writeOffReasonPost: WriteOffReasonPost
}

/**
 * Request parameters for reorderWriteOffReasons operation in WriteOffReasonApi.
 * @export
 * @interface WriteOffReasonApiReorderWriteOffReasonsRequest
 */
export interface WriteOffReasonApiReorderWriteOffReasonsRequest {
    /**
     * 
     * @type {Array<WriteOffReasonReorder>}
     * @memberof WriteOffReasonApiReorderWriteOffReasons
     */
    readonly writeOffReasonReorder: Array<WriteOffReasonReorder>
}

/**
 * WriteOffReasonApi - object-oriented interface
 * @export
 * @class WriteOffReasonApi
 * @extends {BaseAPI}
 */
export class WriteOffReasonApi extends BaseAPI implements WriteOffReasonApiInterface {
    /**
     * Delete a writeoff reason
     * @summary Delete a writeoff reason
     * @param {WriteOffReasonApiDeleteWriteOffReasonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteOffReasonApi
     */
    public deleteWriteOffReason(requestParameters: WriteOffReasonApiDeleteWriteOffReasonRequest, options?: RawAxiosRequestConfig) {
        return WriteOffReasonApiFp(this.configuration).deleteWriteOffReason(requestParameters.writeOffReasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all write off reasons
     * @summary Get all write off reasons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteOffReasonApi
     */
    public getWriteOffReasons(options?: RawAxiosRequestConfig) {
        return WriteOffReasonApiFp(this.configuration).getWriteOffReasons(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch a write off reason
     * @summary Patch a write off reason
     * @param {WriteOffReasonApiPatchWriteOffReasonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteOffReasonApi
     */
    public patchWriteOffReason(requestParameters: WriteOffReasonApiPatchWriteOffReasonRequest, options?: RawAxiosRequestConfig) {
        return WriteOffReasonApiFp(this.configuration).patchWriteOffReason(requestParameters.writeOffReasonPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reorder writeOff reasons
     * @summary Reorder writeOff reasons
     * @param {WriteOffReasonApiReorderWriteOffReasonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteOffReasonApi
     */
    public reorderWriteOffReasons(requestParameters: WriteOffReasonApiReorderWriteOffReasonsRequest, options?: RawAxiosRequestConfig) {
        return WriteOffReasonApiFp(this.configuration).reorderWriteOffReasons(requestParameters.writeOffReasonReorder, options).then((request) => request(this.axios, this.basePath));
    }
}

